import { lesson1, vocab1, audio1, intro1 } from "./lesson1";
import { lesson2, vocab2, audio2, intro2 } from "./lesson2";
import { lesson3, vocab3, audio3, intro3 } from "./lesson3";
import { lesson4, vocab4, audio4, intro4 } from "./lesson4";
import { lesson5, vocab5, audio5, intro5 } from "./lesson5";
import { lesson6, vocab6, audio6, intro6 } from "./lesson6";
import { lesson7, vocab7, audio7, intro7 } from "./lesson7";
import { lesson8, vocab8, audio8, intro8 } from "./lesson8";

export const lessons = [lesson1, lesson1, lesson2, lesson3, lesson4, lesson5, lesson6, lesson7, lesson8];

export const vocabs = [vocab1, vocab1, vocab2, vocab3, vocab4, vocab5, vocab6, vocab7, vocab8];

export const audios = [audio1, audio1, audio2, audio3, audio4, audio5, audio6, audio7, audio8];

export const intros = [intro1, intro1, intro2, intro3, intro4, intro5, intro6, intro7, intro8];